module.exports = __webpack_public_path__ + "static/fonts/c0e9b8ed2fe5addd436afc5ef8391205.b9cec521.ttf";